import {
  FullTask,
  LoggedUser,
  TaskWithSub,
  isOwner,
  projectStatusByCode,
  taskStatusByCode,
} from 'entities';

interface CanCreateSampleProjectParams {
  project?: { status: string };
  task?: FullTask | TaskWithSub;
  user: LoggedUser;
}

export function canCreateSampleProject({
  user,
  project,
  task,
}: CanCreateSampleProjectParams): boolean {
  return [
    taskStatusByCode[task?.status ?? '']?.canCreateSampleProject,
    projectStatusByCode[project?.status ?? '']?.isActiveStatus,
    user.sampleId,
    isOwner(task, user),
    task?.canCreateSampleProject,
  ].every(Boolean);
}
